// extracted by mini-css-extract-plugin
export default {"screen-loading":"BackgroundCheckComplete_screen-loading__IWhn1"};